import common from './common';
import events from './events';

export default {
  common,
  events,
};
